import { Select } from 'antd'
import { useState } from 'react'
import styles from './index.module.scss'

const clarityOptions = [
    { label: '2K', value: '2k' },
    { label: '4K', value: '4k' },
]

const ratioOptions = [
    { label: '2:3', value: '2:3' },
    { label: '1:1', value: '1:1' },
    { label: '3:4', value: '3:4' },
    { label: '16:9', value: '16:9' },
    { label: '9:16', value: '9:16' },
    { label: '3:2', value: '3:2' },
    { label: '4:3', value: '4:3' },
]

const platformOptions = [
    { label: '淘宝', value: 'taobao' },
    { label: '天猫', value: 'tmall' },
    { label: '京东', value: 'jd' },
    { label: '拼多多', value: 'pdd' },
    { label: '抖音电商', value: 'douyin_shop' },
    { label: '唯品会', value: 'vip' },
    { label: '1688', value: '1688' },
    { label: '小红书', value: 'xiaohongshu' },
    { label: '亚马逊', value: 'amazon' },
    { label: 'Tik Tok', value: 'tiktok' },
    { label: 'Shopify', value: 'shopify' },
]

const langOptions = [
    { label: '中文', value: 'cn' },
    { label: '英文', value: 'en' },
    { label: '俄文', value: 'ru' },
]

const OutputConfigPanel = ({
    clarity: controlledClarity,
    onClarityChange,
    ratio: controlledRatio,
    onRatioChange,
    platform: controlledPlatform,
    onPlatformChange,
    lang: controlledLang,
    onLangChange,
}) => {
    const [innerClarity, setInnerClarity] = useState('2k')
    const [innerRatio, setInnerRatio] = useState('3:4')
    const [innerPlatform, setInnerPlatform] = useState('taobao')
    const [innerLang, setInnerLang] = useState('cn')

    const clarity = controlledClarity || innerClarity
    const ratio = controlledRatio || innerRatio
    const platform = controlledPlatform || innerPlatform
    const lang = controlledLang || innerLang

    const handleClarityChange = (nextClarity) => {
        if (controlledClarity === undefined) {
            setInnerClarity(nextClarity)
        }
        onClarityChange?.(nextClarity)
    }

    const handleRatioChange = (nextRatio) => {
        if (controlledRatio === undefined) {
            setInnerRatio(nextRatio)
        }
        onRatioChange?.(nextRatio)
    }

    const handlePlatformChange = (nextPlatform) => {
        if (controlledPlatform === undefined) {
            setInnerPlatform(nextPlatform)
        }
        onPlatformChange?.(nextPlatform)
    }

    const handleLangChange = (nextLang) => {
        if (controlledLang === undefined) {
            setInnerLang(nextLang)
        }
        onLangChange?.(nextLang)
    }

    return (
        <div className={styles.OutputConfigPanel}>
            <div className={styles.ClaritySection}>
                <span className={styles.Label}>分辨率</span>
                <div className={styles.PickerContent}>
                    {clarityOptions.map((item) => (
                        <div
                            key={item.value}
                            className={`${styles.PickerItem} ${clarity === item.value ? styles.actived : ''}`}
                            onClick={() => handleClarityChange(item.value)}
                        >
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles.ConfigItem}>
                <span className={styles.Label}>生成比例</span>
                <Select
                    className={styles.Select}
                    value={ratio}
                    options={ratioOptions}
                    onChange={handleRatioChange}
                />
            </div>

            <div className={styles.ConfigItem}>
                <span className={styles.Label}>电商平台</span>
                <Select
                    className={styles.Select}
                    value={platform}
                    options={platformOptions}
                    onChange={handlePlatformChange}
                />
            </div>

            <div className={styles.ConfigItem}>
                <span className={styles.Label}>语言</span>
                <Select
                    className={styles.Select}
                    value={lang}
                    options={langOptions}
                    onChange={handleLangChange}
                />
            </div>
        </div>
    )
}

export default OutputConfigPanel
